export const GET_CLUB_MEMBERS = "GET_CLUB_MEMBERS";
export const GET_CLUB_MEMBERS_BY_ID = "GET_CLUB_MEMBERS_BY_ID";
export const UPDATE_CLUB_MEMBERS = "UPDATE_CLUB_MEMBERS";
export const DELETE_CLUB_MEMBERS = "DELETE_CLUB_MEMBERS";
export const CREATE_CLUB_MEMBERS = "CREATE_CLUB_MEMBERS";
